import { render, staticRenderFns } from "./subclassify.vue?vue&type=template&id=4f5be941&scoped=true&"
import script from "./subclassify.vue?vue&type=script&lang=js&"
export * from "./subclassify.vue?vue&type=script&lang=js&"
import style0 from "./subclassify.vue?vue&type=style&index=0&id=4f5be941&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5be941",
  null
  
)

export default component.exports